import { Injectable } from '@angular/core';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { UserService } from 'app/Shared/Services/user.service';

@Injectable(
  {providedIn: 'root'}
)
export class CommonGridService {
  public isShowExceptionDetails: boolean = false;
  constructor( private sharedHttpClientService: SharedHttpClientService, 
    private urlsService: UrlsService, 
    private userService: UserService) {
    
   }

  getData(data: any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_Viewer
        ), data)      
  }

  getSymbol(data:any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_QuickFilterFields
        ), data)  
  }

  getExceptionCodes(data: any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Exception_ExceptionCodes_List,
    ), data);
  }

}
